import '../libs/libs.pcss';
import {$, jQuery} from 'jquery';
window.$ = $;
window.jQuery = jQuery;
import angular from 'angular';
import 'core-js/modules/es.array.from';
import 'angular-sanitize';
import 'angular-i18n/angular-locale_hu-hu';
import 'angular-translate';

import 'angular-aria';
import 'angular-animate';
import 'angular-material';
import 'angular-messages';
import 'angular-cookies';

import frame from '../frame/frame';

import filters from './filters/filters.module';
import configFunction from './common-config';
import restrictInputCharactersComponent from './restrictInputCharacters/resrict-input-characters.module';
import fullPageLoader from './fullPageLoader/full-page-loader';
import scrollToElement from './scrollElementIntoView/scroll-to-element';
import notificationService from './notificationService/notification-service.module';
import cookiePolicy from './cookiePolicy/cookie-policy';
import telephoneNumberInputComponent from './directives/telephoneNumberInput/telephone-number-input.moule';
import { onInitializedModule } from './directives/on-initialized/on-initialized.module.js'
const CommonConstants = {
	INVISIBLE_RECAPTCHA_CLIENT_KEY: window.reCaptchaClientKey || '',
	GOOGLE_MAPS_API_KEY: window.MAP_KEY || '',
	EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	WEBSETA_PROPERTY: 'websetaUrl',
	SZIKRA_URL: '/ikr-web',
	AVAILABLE_LANGUAGES: ['hu', 'en'],
	DESKTOP_WIDTH: 992
};

const MODULE_NAME = 'common';
export default angular.module(MODULE_NAME, ['ngMaterial', 'ngSanitize', 'ngMessages', 'pascalprecht.translate', 'ngCookies', frame,
	filters, restrictInputCharactersComponent, fullPageLoader, notificationService, scrollToElement, cookiePolicy, telephoneNumberInputComponent, onInitializedModule])
	.constant('CommonConstants', CommonConstants)
	.config(['$translateProvider', '$provide', '$qProvider', '$compileProvider', configFunction]).name;

